export default __webpack_public_path__ + "static/media/sapporo_icon.f69a18dd.png";